import { PropertyStoreService } from './stores/property-store.service';
import { Property } from '../domain/property';
import { DateTime } from 'luxon';
import DateUtils from '../util/date-utils';
import { HttpApiServiceBase } from './http-api-service-base';
import { environment } from '../../environments/environment';

export class HttpServiceParent extends HttpApiServiceBase {
   protected currentProperty: Property | undefined;
   constructor(private basePropertyStore: PropertyStoreService) {
      super();
      this.basePropertyStore.currentProperty.subscribe((property) => {
         this.currentProperty = property;
      });
   }

   protected getDateStringForApiQueryFromDateTime(date: DateTime): string | null {
      if (
         this.currentProperty &&
         this.currentProperty.isPhobosEnabled &&
         environment.utcQueryStrings
      ) {
         return DateUtils.convertLocalDateTimeToUtcIsoString(
            date,
            this.currentProperty.timeZone
         );
      }
      return date.toISODate();
   }

   protected getDateStringForApiQueryFromDateString(date: string): string | null {
      if (
         this.currentProperty &&
         this.currentProperty.isPhobosEnabled &&
         environment.utcQueryStrings
      ) {
         return DateUtils.convertLocalDateStringToUtcIsoString(
            date,
            this.currentProperty.timeZone
         );
      }
      return date;
   }
}
